<template>
  <div class="title-box">
    <div class="line" v-if="isLine"></div>
    <slot></slot>
  </div>
</template>

<script>
  export default{
    props:{
      isLine:{
        type:Boolean,
        default:true
      }
    }
  }
</script>

<style scoped lang="scss">
  .title-box{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
    color: #000;

    .line{
      border-radius: 2px;
      width: 4px;
      height: 18px;
      background-color: #60B7DC;
      margin-right: 2px;
    }
  }
</style>
